/**
 * Formats a price to display in the format based on the locale.
 * 
 * @param {number} price 
 * @returns A formatted display price
 */
export function formatPrice(price: number, language: string, currency: string, showCents = true) {

    const formatter = new Intl.NumberFormat(language, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: showCents ? 2 : 0
    });

    return formatter.format(price);

}
